import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_a42k6qezb7: FaireBrandEntity = {
  token: "b_a42k6qezb7",
  type: "brand",
  name: "sassy kids palace",
  avatarUrl:
    "https://cdn.faire.com/fastly/aa82a4a91eee7db2b1537d297b7c5b83a607b0c9c68ce0366135fa33a3728df3.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/df02687720ef95be956b0182d006686dbb0220e5bc53e788c603900b25f37882.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/aa82a4a91eee7db2b1537d297b7c5b83a607b0c9c68ce0366135fa33a3728df3.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/df02687720ef95be956b0182d006686dbb0220e5bc53e788c603900b25f37882.jpeg",
  location: "Wylie, TX, USA",
  minimumOrderDollars: 50,
  rating: 4.8,
  reviewCount: 672,
  isInsider: true,
  description:
    "We have been producing and selling kids' bags for 11 years, including backpacks, duffel bags, tote bags, diaper bags, fanny packs, lunch bags, and holiday bags, etc. We have our factory and warehouse, which can produce about 10000 pcs items per day. Reasonable prices, fashion designs, and high quality are our advantages. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:12.849Z",
    importedBy: "entity-db-cli",
  },
};
